<template>
  <b-form-group :class="['multiselect-light-form-group', groupClass]" :state="state">
    <multiselect
      :value="value"
      :id="id"
      :options="options"
      :track-by="trackBy"
      :label="optionLabel"
      :placeholder="placeholder"
      :showLabels="false"
      class="signup-multiselect-light multiselect__single-line"
      @input="$emit('input', $event)"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <span class="label">{{label}}:</span>{{' '}}

        <span v-if="option[optionLabel]">{{option[optionLabel]}}</span>
        <span v-else class="placeholder">{{placeholder}}</span>
      </template>
      <template slot="placeholder">
        <span class="label">{{label}}:</span>{{' '}}
        <span class="placeholder">{{placeholder}}</span>
      </template>
    </multiselect>

    <template #invalid-feedback>
      <slot name="invalid-feedback"></slot>
    </template>
  </b-form-group>
</template>

<script>
export default {
  name: 'SignUpMultiselectLight',
  props: {
    value: {
      type: [Object, null],
      default: null
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    trackBy: {
      type: String,
      required: true
    },
    optionLabel: {
      type: String,
      required: true
    },
    placeholder: String,
    groupClass: String
  }
}
</script>

<style scoped lang="scss">
$font-size: 16px;

.multiselect-light-form-group {
  margin-bottom: 0 !important;

  ::v-deep .invalid-feedback {
    margin-top: -3px !important;
    margin-bottom: 3px;
  }
}

.label {
  font-weight: 700;
  color: $fontColorBase;
}

.placeholder {
  color: $fontColor2;
}

.signup-multiselect-light {
  ::v-deep .multiselect__select {
    width: $sign-in-multiselect-select-width;

    &::before {
      font-size: $sign-in-multiselect-select-font-size;
    }
  }

  ::v-deep .multiselect__tags {
    padding-left: 0;
    font-size: $font-size;
    background-color: transparent;
    border: none;

    .multiselect__input {
      font-size: $font-size;
    }

    .multiselect__placeholder, input::placeholder {
      font-size: $font-size;
      font-weight: 400;
      color: $fontColor2;
    }

    .multiselect__single {
      font-size: $font-size;
      font-weight: 400;
    }
  }

  ::v-deep .multiselect__content-wrapper {
    border: 1px solid $inputBorderColor1 !important;
    border-radius: 5px !important;
    background-color: #FFF;
  }

  ::v-deep .multiselect__option {
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: $font-size;
    font-weight: 500;
  }
}
</style>
